// extracted by mini-css-extract-plugin
export default {"radio-group":"radio-group_radio-group__fcGRC","label":"radio-group_label__oLITu"};